import { render, staticRenderFns } from "./company-team.vue?vue&type=template&id=5e0f79f6&scoped=true&"
import script from "./company-team.vue?vue&type=script&lang=js&"
export * from "./company-team.vue?vue&type=script&lang=js&"
import style0 from "./company-team.vue?vue&type=style&index=0&id=5e0f79f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0f79f6",
  null
  
)

export default component.exports